import React from "react";

const subjectsByYear = {
  firstYear: [
    { id: 1, name: "English" },
    { id: 2, name: "Nepali" },
    { id: 3, name: "Social Studies (Nepali Parichaya)" },
    { id: 4, name: "Mathematics Statistics & Computer Application" },
    { id: 5, name: "Physics" },
    { id: 6, name: "Chemistry" },
    { id: 7, name: "Zoology" },
    { id: 8, name: "Botany" },
    { id: 9, name: "Anatomy & Physiology" },
  ],
  secondYear: [
    { id: 1, name: "Medicine-I" },
    { id: 2, name: "Surgery-I" },
    { id: 3, name: "Gynecology & Procedures/First Aid" },
    { id: 4, name: "Foundation of Health Education" },
    { id: 5, name: "Clinical Pharmacology Education" },
    { id: 6, name: "Primary Health Care/Family Health" },
    { id: 7, name: "Clinical Pharmacology and Pharmacy" },
    { id: 8, name: "Environmental Health" },
  ],
  thirdYear: [
    { id: 1, name: "Medicine-II (Pediatrics)" },
    { id: 2, name: "Medicine-II (Psychiatry)" },
    { id: 3, name: "Medicine-II (Dermatology)" },
    { id: 4, name: "Surgery-II (ENT)" },
    { id: 5, name: "Surgery-II (Dentistry)" },
    { id: 6, name: "Surgery-II (Ophthalmology)" },
    { id: 7, name: "Health Management" },
    { id: 8, name: "Epidemiology" },
    { id: 9, name: "Comprehensive Clinical Practice (4 Months) " },
    { id: 10, name: "Comprehensive Community Field Practice (2 Months) " },
  ],
};

const SubjectTable = ({ year, subjects }) => (
  <div className="md:px-0 px-4 flex justify-center">
    <div className="w-full md:w-10/12">
      <h2 className="text-lg font-semibold mb-2">{year} Subjects</h2>
      <div className="shadow-md rounded-lg overflow-hidden">
        <table className="min-w-full bg-white">
          <thead className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
            <tr>
              <th className="py-3 px-6 text-left">Subject Name</th>
            </tr>
          </thead>
          <tbody>
            {subjects.map((subject) => (
              <tr
                key={subject.id}
                className="border-b border-gray-200 hover:bg-gray-100"
              >
                <td className="py-3 px-6 text-left whitespace-normal">
                  {subject.name}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

const HaSubjects = () => {
  return (
    <div>
      <h1 className="  md:px-0 px-4 text-xl md:text-2xl font-serif font-semibold md:text-center mb-6 md:mb-10">
        PCL In General Medicine (HA)
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-5">
        <SubjectTable year="First Year" subjects={subjectsByYear.firstYear} />
        <SubjectTable year="Second Year" subjects={subjectsByYear.secondYear} />
        <SubjectTable year="Third Year" subjects={subjectsByYear.thirdYear} />
      </div>
    </div>
  );
};

export default HaSubjects;
